import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaHeart } from "react-icons/fa";
import { MdOutlineShoppingCart } from "react-icons/md";
import { PiNotePencilBold } from "react-icons/pi";
import { IoPersonSharp } from "react-icons/io5";
import { IoIosLogOut } from "react-icons/io";
import { IoMdCart } from "react-icons/io";
import "./uheader.css";
import Fuse from "fuse.js";
import logo from "../../assests/logo.png";

const Header = ({
  bagcount,
  wishlistcount,
  isScrolled,
  products,
  setBag,
  setWishlist,
  header,
  userData,
  StorageClear,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSearch = () => {
    const options = {
      keys: ["prod_name"],
      threshold: 0.4,
    };

    const fuse = new Fuse(products, options);
    const result = fuse.search(searchText);

    const filtered = result.map((res) => res.item);

    navigate("/search", { state: { results: filtered, query: searchText } });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userData"));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  const [logoutTrigger, setLogoutTrigger] = useState(0);

  const handleLogout = () => {
    localStorage.removeItem("userData");
    setUser(null);
    setIsOpen(false);
    // navigate("/");
    StorageClear();
    setLogoutTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    // const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    if (!userData?.id) {
      setBag([]);
      setWishlist([]);
    }
  }, [logoutTrigger]);


  console.log(header);
  
  return (
    <div className="ecom-header">
      <div
        className={`ecom-header-container ${location.pathname === "/" && !isScrolled ? "TextColor" : "scrolled"
          }`}
      >
        <div className={`logo1 ${isScrolled ? "scrolled" : "scrolled"}`}>
          <Link to="/">
            <img src={logo} alt="logo" className="logoo" />{" "}
          </Link>
        </div>

        <div className="usearch-bar">
          <input
            type="text"
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search products..."
          />
          <button type="submit" className="button" onClick={handleSearch}>
            Search
          </button>
        </div>

        <div className="header-icons">
          {/* <Link
            to="/quotation"
            className={`icon-link ${location.pathname === "/quotation" ? "active" : ""
              }`}
          >
            <div className="icon-wrapper">
              <span className="icons">
                <PiNotePencilBold />
              </span>
            </div>
            <span className="icon-label">Quotation</span>
          </Link> */}

          <Link
            to="/bag"
            className={`icon-link ${location.pathname === "/bag" ? "active" : ""
              }`}
          >
            <div className="icon-wrapper">
              <span className="icons">
                <MdOutlineShoppingCart />
              </span>
              {bagcount > 0 && <span className="cart-count">{bagcount}</span>}
            </div>
            <span className="icon-label">Bag</span>
          </Link>

          <Link
            to="/wishlist"
            className={`icon-link ${location.pathname === "/wishlist" ? "active" : ""
              }`}
          >
            <div className="icon-wrapper">
              <span className="icons">
                <FaHeart />
              </span>
              {wishlistcount > 0 && (
                <span className="cart-count">{wishlistcount}</span>
              )}
            </div>
            <span className="icon-label">Wishlist</span>
          </Link>

          <div className="profile-menu">
            {user ? (
              <>
                <div className="icon-link"
                  onClick={toggleMenu}
                  onMouseEnter={() => setIsOpen(true)}
                >
                  <div className="icon-wrapper">
                    <span className="icons">
                      <IoPersonSharp />
                    </span>
                  </div>
                  <span className="icon-label">{user?.name}</span>
                </div>

                {isOpen && (
                  <div ref={menuRef} onMouseLeave={() => setIsOpen(false)} className="menu-box">
                    <ul>
                      <li>
                        <Link to="/profile" className="menu-link">
                          <span>Profile</span>
                          <IoPersonSharp />
                        </Link>
                      </li>
                      <li>
                        <Link to="/orders" className="menu-link">
                          <span>My Orders</span>
                          <IoMdCart />
                        </Link>
                      </li>
                      <li>
                        <span
                          onClick={handleLogout}
                          className="menu-link red"
                        // style={{
                        //   background: "none",
                        //   border: "none",
                        //   width: "100%",
                        //   textAlign: "left",
                        // }}
                        >
                          <span>Logout</span>
                          <IoIosLogOut />
                        </span>
                      </li>
                    </ul>
                  </div>
                )}
              </>
            ) : (
              <Link to="/usersign" className="icon-link">
                <div className="icon-wrapper">
                  <span className="icons">
                    <IoPersonSharp />
                  </span>
                </div>
                <span className="icon-label">Login</span>
              </Link>
            )}
          </div>
        </div>
      </div>

      {location.pathname === "/" && isScrolled && (
        <div className="top-header scrolled-header">
          <div className="top-center">
            {header?.map((category, index) => (
              <div className="menu-item" key={index}>
                {category.header}

                <div className="dropdown-box">
                  {category.subs?.map((sub, subIndex) => (
                    <div key={subIndex}>{sub}</div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {location.pathname !== "/" && (
        <div className="top-header">
          <div className="top-center">
            {header?.map((category, index) => (
              <div className="menu-item" key={index}>
                {category.header}

                <div className="dropdown-box">
                  {category.subs?.map((sub, subIndex) => (
                    <div key={subIndex}>{sub}</div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div >
  );
};

export default Header;
